import { API_URL } from '../config/api';

export interface DepositInfo {
  amount: number;
  status: 'pending' | 'validated' | 'paid' | 'refunded' | 'transferred' | 'rejected';
  validated?: boolean;
  validatedAt?: string;
  paymentIntentId?: string;
  paidAt?: string;
  refundId?: string;
  refundedAt?: string;
  transferId?: string;
  transferredAt?: string;
}

class DepositService {
  private baseUrl = API_URL;

  /**
   * Valider le dépôt par le locataire
   */
  async validateDeposit(bookingId: string, renterId: string, accepted: boolean): Promise<{ success: boolean; error?: string }> {
    try {
      const response = await fetch(`${this.baseUrl}/api/deposit/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          bookingId,
          renterId,
          accepted
        })
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Erreur lors de la validation du dépôt'
        };
      }

      return {
        success: true
      };
    } catch (error) {
      console.error('Erreur validation dépôt:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erreur de connexion au serveur'
      };
    }
  }

  /**
   * Récupérer les détails du dépôt pour une réservation
   */
  async getDepositInfo(bookingId: string): Promise<{ success: boolean; deposit?: DepositInfo; error?: string }> {
    try {
      const response = await fetch(`${this.baseUrl}/api/deposit/${bookingId}`);
      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Erreur lors de la récupération du dépôt'
        };
      }

      return {
        success: true,
        deposit: data.deposit
      };
    } catch (error) {
      console.error('Erreur récupération dépôt:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erreur de connexion au serveur'
      };
    }
  }
}

export const depositService = new DepositService();

